import React, { ReactNode, useReducer } from 'react';
import {
    CreateMultipleUserContext,
    CreateMultipleUserDispatchContext,
    defaultState,
} from './CreateMultipleUserContext';
import { multipleUserCreationReducer } from './CreateMultipleUserReducer';
import { useGetDefaultUser } from './hooks';

const CreateMultipleUserProvider = ({ children }: { children: ReactNode }) => {
    const defaultUser = useGetDefaultUser();
    const [state, dispatch] = useReducer(multipleUserCreationReducer, {
        ...defaultState,
        users: [defaultUser, defaultUser],
    });

    return (
        <CreateMultipleUserContext.Provider value={state}>
            <CreateMultipleUserDispatchContext.Provider value={dispatch}>
                {children}
            </CreateMultipleUserDispatchContext.Provider>
        </CreateMultipleUserContext.Provider>
    );
};

export default CreateMultipleUserProvider;
